import { render, staticRenderFns } from "./publicnav.vue?vue&type=template&id=1a5442fe&scoped=true&"
import script from "./publicnav.vue?vue&type=script&lang=js&"
export * from "./publicnav.vue?vue&type=script&lang=js&"
import style0 from "./publicnav.vue?vue&type=style&index=0&id=1a5442fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5442fe",
  null
  
)

export default component.exports